import { CopyResourceDc, CopyResourceResultDc } from "@evergis/api";
import { Mutation } from "@evergis/react-fetching/es/createMutation";

import { copyResources } from "../../../../resources/resources";

interface CopyResourcesResponse {
  copyJob: Mutation<CopyResourceDc[], CopyResourceResultDc[]>;
  copyData: CopyResourceResultDc[];
  copyLoading: boolean;
  copyError: Error;
}

export const useCopyResources = (): CopyResourcesResponse => {
  const [copyJob, { data: copyData, loading: copyLoading, error: copyError }] = copyResources.use();

  return {
    copyJob,
    copyData,
    copyLoading,
    copyError,
  };
};
